import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useCallback } from 'react';
import { NumberFormatValues, NumericFormat, NumericFormatProps } from 'react-number-format';

type Props = Omit<NumericFormatProps, 'size' | 'onChange'> &
    Omit<TextFieldProps, 'onChange'> & {
        onChange: (value: string) => void;
    };

export const NumberTextField = ({ onChange, name, ...props }: Props) => {
    const handleChange = useCallback((values: NumberFormatValues) => onChange(values.value), [onChange]);

    return (
        <NumericFormat
            thousandSeparator=","
            valueIsNumericString={true}
            decimalScale={2}
            allowNegative={false}
            name={name}
            {...props}
            customInput={TextField}
            onValueChange={handleChange}
        />
    );
};
